import { z } from 'zod';
import { GDPR_EXPORT_STATUSES } from '../constants/gdpr-export.js';
import { userIdSchema } from './user-id.js';
export const GdprExportStatusSchema = z.enum(GDPR_EXPORT_STATUSES);
export const DataExportRequestSchema = z.object({
    id: z.string().uuid(),
    user_id: userIdSchema,
    status: GdprExportStatusSchema,
    download_token: z.string(),
    storage_path: z.string().nullable(),
    expires_at: z.string().datetime(),
    error_message: z.string().nullable(),
    created_at: z.string().datetime(),
    completed_at: z.string().datetime().nullable(),
});
//# sourceMappingURL=gdpr-export.js.map